import { render } from "./GroupRules.vue?vue&type=template&id=19ae3aa0&scoped=true"
import script from "./GroupRules.vue?vue&type=script&lang=js"
export * from "./GroupRules.vue?vue&type=script&lang=js"

import "./GroupRules.vue?vue&type=style&index=0&id=19ae3aa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ae3aa0"]])

export default __exports__